// Utilities
//import _ from 'lodash';

// Services
import VehiclesService from '@/services/vehicles';

const defaultState = () => ({
  loading: [],
  data: [],
  totalItems: 0,
  perPage: 10,
  page: 1,
  search: {
    customer_id: null,
    all: '',
    status_code: 'A',
  },
  errors: [],
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    reset(state) {
      const options = [].concat(state.options);
      // Prevent options from being assigned
      Object.assign(state, defaultState(), { options });
    },
    switchLoading(state, loadingLabel = '') {
      const labelIndex = state.loading.findIndex(l => l === loadingLabel);
      if (labelIndex > -1) {
        state.loading.splice(labelIndex, 1);
      } else {
        state.loading.push(loadingLabel);
      }
      // NOTE: Workaround for Vue ob object
      if (state.loading.length < 1) {
        state.loading = [];
      }
    },
    data: (state, data = []) => (state.data = data),
    totalItems: (state, data = 0) => (state.totalItems = data),
    perPage: (state, data = 10) => (state.perPage = data),
    page: (state, data = 1) => (state.page = data),
    errors: (state, data) => (state.errors = data),
    search: (state, data) => Object.assign(state.search, data),
  },
  actions: {
    async load({ commit, state }) {
      commit('switchLoading', 'vehicles');
      const response = await VehiclesService.get(
        state.page,
        state.perPage,
        state.search
      )
        .then(r => r.data)
        .catch(err => commit('errors', [`${err.name}: ${err.message}`]));
      commit('switchLoading', 'vehicles');
      commit('data', response.data);
      commit('totalItems', response.total_items);
      commit('perPage', response.length);
      commit('page', response.page);
    },
  },
};
